import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const textVariants = cva('', {
  variants: {
    variant: {
      pageTitle: 'text-2xl sm:text-3xl font-semibold text-neutral-900',
      sectionTitle: 'text-xl font-semibold text-neutral-900',
      body: 'text-base text-neutral-700',
      muted: 'text-sm text-neutral-500',
      label: 'text-sm font-medium text-neutral-700',
      error: 'text-sm font-medium text-error-600',
      pill: 'text-xs font-semibold text-neutral-700',
    },
  },
  defaultVariants: {
    variant: 'body',
  },
});

interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  asChild?: boolean;
}

// Purpose: Provide consistent typography variants across feature UI.
export const Text = React.forwardRef<HTMLElement, TextProps>(
  ({ asChild = false, className, variant, ...props }, ref) => {
    const Component = asChild ? Slot : 'span';
    return (
      <Component ref={ref} className={cn(textVariants({ variant }), className)} {...props} />
    );
  }
);

Text.displayName = 'Text';
